module.exports = __webpack_public_path__ + "img/Phone-icon.639aa52c.svg";